module.exports = __webpack_public_path__ + "assets/media/day26.68b2a2c1.mp3";